import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconLogoutOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="m16.81 6.93 1.06-1.06L24 12l-6.13 6.13-1.06-1.06 4.319-4.32H10.84v-1.5H21.13zM13.5 22.5v-3.75H15v3.75a1.5 1.5 0 0 1-1.5 1.5h-12A1.5 1.5 0 0 1 0 22.5v-21A1.5 1.5 0 0 1 1.5 0h12A1.5 1.5 0 0 1 15 1.5v3.75h-1.5V1.5h-12v21z" /></svg>
);
